import {LoginResult, PublishingRoles} from "../services/accountService/models/AccountType";
import {getRolesFromToken, gzipProviderInstance, useCookieContext} from "../contexts";

export const getUserSession = ():LoginResult | null=>{
    const userInfo = localStorage.getItem("Session");
    if (userInfo) {
     
        const decompressedSession = gzipProviderInstance.decompress(userInfo || "");
        const userRoles = getRolesFromToken(decompressedSession);
        const user = JSON.parse(decompressedSession) as LoginResult;
        user.roles = userRoles as PublishingRoles[];
        return user;
    }
    return null;
}   